<template>
  <span>
    <v-menu offset-y
      v-if="showMenu()">
      <template v-slot:activator="{ on, attrs }">
        <v-chip
          v-bind="attrs"
          v-on="on"
          text-color="white"
          :small="small"
          :color="statusColor(status)">
          <strong>{{ getStatusName(status) }}</strong>
          <v-icon class="ml-1">
            mdi-menu-down
          </v-icon>
        </v-chip>
      </template>

      <v-list>
        <v-list-item
          v-for="(item, i) in mnus"
          :key="i"
          link
          @click="statusChange(item)"
        >
          <v-list-item-title>{{getStatusName(item)}}</v-list-item-title>
        </v-list-item>
      </v-list>
    </v-menu>

    <v-chip
      v-if="!showMenu()"
      text-color="white"
      :small="small"
      :color="statusColor(status)">
      <strong>{{ getStatusName(status) }}</strong>
    </v-chip>

  </span>
</template>

<script>
  import { mapGetters } from "vuex";

  export default {
    name: 'BookingStatusSelect',
    props: ['status', 'small', 'mnus', 'bookingType', 'itemId', 'statuses'],
    data: () => ({
    }),
    computed: {
      ...mapGetters(['getStatusColor']),
    },
    watch: {

    },
    methods: {
      showMenu (){
        if(this.status == this.$getConstBookingStatus('BOOKING_STATUS_AGENT_VIEWED') && this.bookingType == 'main'){
          return true
        }else if(this.status > this.$getConstBookingStatus('BOOKING_STATUS_AGENT_VIEWED') &&
          this.status > this.$getConstBookingStatus('BOOKING_STATUS_CANCELLED') && 
          this.status < this.$getConstBookingStatus('BOOKING_STATUS_ARRIVED') && this.bookingType == 'item'){
          return true
        }
        return false
      },
      statusColor (statusId){
        return this.getStatusColor(statusId, this)
      },
      statusChange (id){
        let item = {
          id: this.itemId,
          bookingType: this.bookingType,
          status: id
        }

        this.$emit('statusChange', item)
      },
      getStatusName: function(id){
        let statuses = this.statuses.filter(status => {
          return status.id == id
        })
        if(statuses.length > 0){
          return statuses[0].name
        }
      }
    },
    mounted() {
    },
    components: {
    }
  }
</script>
